(function () {
    'use strict';

    angular
        .module('app')
        .controller('carryoverController', function carryoverController($scope, $rootScope, $timeout, $state, CarryoverService, LinePlanService, PrototypeService, BrandService, SeasonService, toaster, CarryoverData, cfpLoadingBar) {
            var model = this;

            $scope.permissionDenied = function () {
                $state.go('permissionDenied');
            }

            $scope.goToUserPage = function (data) {
                $state.go(data.pageName, data.params);
            }

            $scope.loaderClosed = function () {
                cfpLoadingBar.complete();
            }

            $scope.loaderStart = function () {
                cfpLoadingBar.start();
            }
            angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
                if (userPermissionRow[0] == 14) {
                    if (userPermissionRow[1] == 2) {
                        model.CarryoverEdit = true;
                    }
                }
            });

            if (!model.CarryoverEdit) {
                $state.go('permissionDenied');
            }

            model.isDisabled = true;
            model.brandId = "";
            model.patternId = 0;
            model.radioValue = "";
            model.patternsCount = -1;
            model.prototypes1 = [];
            model.carriedoverProtos = [];
            model.linePlans = "";
            model.fromSeasoId = 0;
            model.carryovertoPattern = "";
            model.carryovertoBrief = "";
            model.pattern = [];
            model.brief = [];
            model.coPrototypes = [];
            model.fromSeasonName = "";


            //it's always true, needs to have a length, otherwise, redirect
            //if (CarryoverData.data) {
            if (CarryoverData.data.length > 0) {
                model.prototypes1 = CarryoverData.data;

                model.brandId = model.prototypes1[0].BrandId;
                model.fromSeasonId = model.prototypes1[0].SeasonId;
                model.fromSeasonName = model.prototypes1[0].SeasonName;

                //this is a temporary hack for carryover that will auto hide the loader -ben 11/28/2017
                //BrandService.getBrandsByUser().then(function (data) {
                //    model.brands = data;
                //    cfpLoadingBar.complete();
                //});

            } else {
                //$state.go('carryover');
            }

            function getSeasonsByBrand(brandId) {
                if (brandId) {

                    SeasonService.getShiftCarryoverSeasonsByBrand(brandId, model.fromSeasonId).then(function (data) {
                        if (data.length > 0) {
                            model.seasons = data;
                        }
                        else {
                            toaster.pop({ type: 'warning', title: 'Alert!', body: 'No available line plans were found.', timeout: 3000 });
                        }

                        cfpLoadingBar.complete();
                    });
                }
            }

            getSeasonsByBrand(model.brandId);

            model.validPrototypes = function () {
                var validProtos = _.countBy(model.prototypes1, function (proto) {
                    return (proto.carryoverExists == true)
                });
                var areValid = (validProtos.false > 0);
                return (areValid);
            };

            model.verifyNoCarryover = function (seasonId, linePlanId) {
                if (linePlanId != undefined && seasonId != undefined) {

                    var searchObjects = [];
                    model.prototypesLoading = true;

                    angular.forEach(model.prototypes1,
                        function (proto) {
                            proto.carryoverExists = false;
                            proto.carryoverPrototypeSeasonalId = null;
                            var searchObject = {
                                SeasonId: seasonId,
                                FactNameKy: proto.FactNameKy,
                                PageSize: 0,
                                PrototypeId: proto.PrototypeId
                            };
                            searchObjects.push(searchObject);
                        });

                    PrototypeService.multiSearchPrototypes(searchObjects)
                        .then(function (response) {
                            angular.forEach(response,
                                function (proto) {

                                    var coItem = model.prototypes1.filter(function (carryoverItem) {
                                        return carryoverItem.PrototypeId == proto.PrototypeId;
                                    });

                                    coItem[0].carryoverExists = true;
                                    coItem[0].carryoverPrototypeSeasonalId = proto.PrototypeSeasonalId;

                                    toaster.pop({ type: 'error', title: 'Error!', body: 'Some of these Prototypes have been Carried Over and will not be moved - ' + proto.Name, timeout: 5000 });
                                });
                            model.prototypesLoading = false;

                        }, function (error, status) {
                            toaster.pop({ type: 'error', title: 'Error!', body: 'There was an error. Please contact system administrator', timeout: 5000 });
                        });
                }
            };


            //   get list of line plans to select from
            model.getLinePlansByBrandSeason = function (brandId, seasonId) {
                if (seasonId === model.fromSeasonId) {
                    $scope.carryoverForm.toseason.$setValidity('CarryOverToSeasonDifferent', false);
                    cfpLoadingBar.complete();
                } else {
                    LinePlanService.getLinePlansByBrandSeason(brandId, seasonId, 0).then(function (response) {
                        $scope.carryoverForm.toseason.$setValidity('CarryOverToSeasonDifferent', true);
                        if (response) {

                            cfpLoadingBar.complete();

                            model.linePlans = [];

                            response.forEach(function (lp) {
                                //only line plans in released status should be available
                                if (lp.StatusName == "Released" || lp.StatusName == "Completed") {
                                    model.linePlans.push(lp);
                                }
                            });

                            if (model.linePlans.length < 1) {
                                toaster.pop({ type: 'error', title: 'Error!', body: 'No Line Plan Found', timeout: 5000 });
                            }

                        } else {
                            toaster.pop({ type: 'error', title: 'Error!', body: 'No Line Plan Found', timeout: 5000 });
                        }
                    });
                }
            };

            function resetValues() {
                $scope.carryoverForm.toseason.$setUntouched();
                $scope.carryoverForm.toLineplan.$setUntouched();
                CarryoverData.data = [];
                model.prototypes1 = [];
            }

            function doCarryover() {
                CarryoverService.doPrototypeCarryover(model.prototypes1, model.fromSeasonId, model.carryoverseason.selectedtoSeason.SeasonId, model.toLinePlan.LinePlanId).then(function (carriedoverProtots) {
                    cfpLoadingBar.complete();
                    model.carriedoverProtos = carriedoverProtots;
                    if (carriedoverProtots) {
                        if (model.isForecasting === true) {
                            CarryoverData.data = carriedoverProtots;
                            if (CarryoverData.data.length > 0) {
                                $state.go("carryoverConform");
                            } else {
                                toaster.pop({ type: 'success', title: 'Success!', body: 'Carryover Completed Successfully, No Prototypes found for Forecasting. Please check your email for further details', timeout: 5000 });
                                $state.go("carryover");
                            }
                        } else {
                            toaster.pop({
                                type: 'success', title: 'Success!', body: 'Carryover Completed Successfully, Please Check the email for confirmation.', timeout: 5000
                            });

                            $timeout(function () {
                                $state.go("carryover");
                            });
                        }
                    } else {
                        toaster.pop({ type: 'error', title: 'Error!', body: 'Unexpected error occured during the carryover process.', timeout: 5000 });
                    }
                },
                    function (error, status) {
                        toaster.pop({ type: 'error', title: 'Error!', body: 'Unexpected error occured in Carryover', timeout: 5000 });
                    });

            };

            model.carryover = function () {
                model.isForecasting = false;
                doCarryover();
            };

            model.carryoverforecasting = function () {
                model.isForecasting = true;
                doCarryover();
            };
        });
})();

